import { z } from 'zod';
import { listSearchSchema } from '@/shared/patterns/list-search';
import { creditProductFilters } from './credit-product.filters';
export const CREDIT_PRODUCT_TABS = [
  'informacoes',
  'envolvidos',
  'documentos',
  'templates',
  'documentos-para-assinatura',
  'custo-de-emissao',
  'orgao',
] as const;
export type CreditProductTab = (typeof CREDIT_PRODUCT_TABS)[number];
export const creditProductListSearch = listSearchSchema({
  ...creditProductFilters.shape,
  sheet: z.string().optional(),
});
export const creditProductDetailSearch = z.object({
  tab: z.enum(CREDIT_PRODUCT_TABS).optional().catch(undefined),
  sheet: z.string().optional(),
});
